<template>
  <div
    v-resize:window="handleResize"
    class="absolute top-0 left-0 right-0 bottom-0 z-[3] flex items-start justify-center bg-white/25"
    :style="{ top: overlayTop + 'px' }"
  >
    <div
      id="demo-sections-locked-content"
      class="relative z-10 max-w-lg mx-auto py-12 md:py-24 px-4 text-center"
      style="background: radial-gradient(circle, white, transparent)"
    >
      <div class="flex justify-center mb-6">
        <div class="relative">
          <div
            class="p-4 sm:p-6 bg-gradient-to-br from-yellow-500/20 to-yellow-400/10 rounded-full shadow-lg"
          >
            <!-- bulb, star, heart, bolt, restaurant, gamepad, child-head, pizza-slice, utensils -->
            <BaseIcon
              icon="book-alt"
              class="text-3xl sm:text-4xl text-yellow-600"
            />
          </div>
          <!-- Play ring -->
          <div
            class="absolute inset-0 rounded-full border-2 border-yellow-500/30"
          ></div>
        </div>
      </div>

      <h1 class="text-2xl sm:text-3xl font-black text-gray-900 mb-4">
        {{ $t('demo.locked.title') }}
      </h1>

      <div class="flex justify-center mb-6">
        <div class="flex flex-col items-center gap-2">
          <div class="text-base text-gray-600 font-medium">
            {{ $t('demo.locked.subtitle') }}
          </div>
        </div>
      </div>

      <BaseButton
        class="mb-8 text-gray-900"
        color="transparent"
        @click="() => $emit('show-more')"
      >
        <div class="flex items-center justify-center gap-3">
          <BaseIcon icon="eye" class="text-xl" />
          <span>{{ $t('demo.locked.discoverAllTopics') }}</span>
        </div>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
  name: 'DemoSectionsLocked',

  components: { BaseIcon, BaseButton },

  data() {
    return {
      overlayTop: 0,
      resizeObserver: null,

      windowWidth: 0
    }
  },

  mounted() {
    this.setupResizeObserver()
  },

  beforeUnmount() {
    this.cleanupResizeObserver()
  },

  methods: {
    setupResizeObserver() {
      this.$nextTick(() => {
        const invisibleSectionsList = document.getElementById(
          'invisible-sections-list'
        )
        if (invisibleSectionsList) {
          // Create ResizeObserver to watch for size changes
          this.resizeObserver = new ResizeObserver(() => {
            this.updateOverlayPosition()
          })

          // Start observing the invisible sections list element
          this.resizeObserver.observe(invisibleSectionsList)

          // Initial position calculation
          this.updateOverlayPosition()
        }
      })
    },

    cleanupResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    },

    updateOverlayPosition() {
      this.$nextTick(() => {
        const element = document.getElementById('invisible-sections-list')
        if (!element) return

        this.overlayTop = element.clientHeight + 8
      })
    },

    handleResize({ x }) {
      this.windowWidth = x
    }
  }
}
</script>
